<template>
    <Combobox 
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        @input.stop
        >
            <div class="tw-relative tw-mt-1">
                <div
                    class="tw-relative"
                >
                    <ComboboxInput
                        class="tw-appearance-none tw-border 
                        tw-rounded tw-w-full tw-py-2 tw-px-3 
                        tw-text-gray-700 tw-leading-tight 
                        tw-focus:tw-outline-none tw-focus:tw-shadow-outline"

                        :displayValue="(item) => item && item.field ? display(item[field]) : display(item)"
                        @change="query = $event.target.value"
                    />
                </div>
                <TransitionRoot
                    leave="tw-transition tw-ease-in tw-duration-100"
                    leaveFrom="tw-opacity-100"
                    leaveTo="tw-opacity-0"
                    @after-leave="query = ''"
                >
                    <ComboboxOptions
                        class="tw-absolute tw-mt-1 tw-max-h-60 tw-w-full tw-overflow-auto tw-rounded-md tw-bg-white tw-py-1 tw-text-base tw-shadow-lg tw-ring-1 
                        tw-ring-black tw-ring-opacity-5 focus:tw-outline-none sm:tw-text-sm tw-z-10"
                    >
                        <div
                            v-if="filteredItems.length === 0 && query !== ''"
                            class="tw-relative tw-cursor-default tw-select-none tw-py-2 tw-px-4 tw-text-gray-700"
                        >
                            Nothing found.
                        </div>

                        <ComboboxOption
                            v-for="item in filteredItems"
                            as="template"
                            :key="item.id ? item.id : item"
                            :value="item"
                            v-slot="{ selected, active }"
                        >
                            <li
                                class="tw-relative tw-cursor-pointer tw-select-none tw-p-4"
                                :class="{
                                    'tw-bg-gray-600 tw-text-white': active,
                                    'tw-text-gray-900': !active,
                                }"
                            >
                                <span
                                    class="tw-block tw-truncate"
                                    :class="{ 'tw-font-medium': selected, 'tw-font-normal': !selected }"
                                >
                                    {{ item && item.field ? display(item[field]) : display(item)}}
                                </span>
                            </li>
                        </ComboboxOption>
                    </ComboboxOptions>
                </TransitionRoot>
            </div>
        </Combobox>
</template>

<script setup>
    import { ref, computed } from 'vue'
    import {
        Combobox,
        ComboboxInput,
        ComboboxButton,
        ComboboxOptions,
        ComboboxOption,
        TransitionRoot,
    } from '@headlessui/vue'
    //import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'


    const props = defineProps({
        items: {
            type: Array,
            default: () => []
        },
        field: String,
        display: {
            type: Function,
            default: (val) => {
                return val
            }
        },
        modelValue: [Object,String]
    })

    let query = ref('')

    let filteredItems = computed(() => {
        const WHITESPACE = /\s+/g;
        if ( query.value == '' ) return props.items;

        return props.items.filter((item) => {
            let searchVal = item && props.field && item[props.field] ? item[props.field] : item;
            return (searchVal || '')
                .toLowerCase()
                .replace(WHITESPACE,'')
                .includes(query.value.toLowerCase().replace(WHITESPACE,''))

        })
    })
</script>

